import { Image as BlurredBackground } from '@/pages/CompanyReport/components/Overview/components/Header/components/BlurredBackground';
import { NarrativeCreateButton } from '../NarrativeCreateButton';
import { getNarrativeCommunityTitle } from './utils';
import { NarrativeCommunityBreadcrumbs } from '../NarrativeCommunityBreadcrumbs';
import { NarrativeCommunityDefaultHeader } from './components/NarrativeCommunityDefaultHeader';
import { NarrativeCommunityCompanyHeader } from './components/NarrativeCommunityCompanyHeader';

type Props = {
  primaryIndustryLabel: string | undefined | null;
  primaryIndustrySlug: string | undefined | null;
  companyNameSlug: string | undefined | null;
  exchangeTicker: string | undefined | null;
  market: string | undefined | null;
  companyName: string | undefined | null;
  companyId: string | undefined | null;
  isLoading: boolean;
  website: string | undefined | null;
  uniqueSymbol: string | undefined | null;
  coverImageUrl: string | undefined | null;
  companyCanonicalUrl: string | undefined | null;
};

export const NarrativeCommunityHeader = ({
  primaryIndustryLabel,
  primaryIndustrySlug,
  companyNameSlug,
  exchangeTicker,
  market,
  companyName,
  companyId,
  isLoading,
  website,
  uniqueSymbol,
  coverImageUrl,
  companyCanonicalUrl,
}: Props) => {
  const title = getNarrativeCommunityTitle({
    companyName,
    primaryIndustryLabel,
    market,
  });
  const hasBreadcrumbs = !!market;

  return (
    <div className="border relative grid grid-rows-[repeat(2,max-content)] border-none bg-surface-1 px-x2 py-x3 text-solid md:rounded-lg md:border-solid md:border-subtle md:px-x4">
      {exchangeTicker && coverImageUrl && (
        <BlurredBackground src={coverImageUrl} alt="logo" />
      )}
      <div className="grid min-h-9 grid-cols-[1fr_max-content] items-center gap-x1">
        {hasBreadcrumbs ? (
          <NarrativeCommunityBreadcrumbs
            market={market}
            primaryIndustrySlug={primaryIndustrySlug}
            exchangeTicker={exchangeTicker}
            companyNameSlug={companyNameSlug}
            companyName={companyName}
          />
        ) : isLoading ? (
          <div className="bones max-w-[300px]" />
        ) : (
          <h1 className="m-0 text-xl font-bold [word-break:break-word]">
            {title}
          </h1>
        )}
        <div className="hidden lg:grid">
          <NarrativeCreateButton companyId={companyId} />
        </div>
      </div>
      {exchangeTicker ? (
        <NarrativeCommunityCompanyHeader
          companyName={companyName}
          uniqueSymbol={uniqueSymbol}
          website={website}
          narrativesCount={undefined}
          commentsCount={undefined}
          fairValuesCount={undefined}
          companyCanonicalUrl={companyCanonicalUrl}
        />
      ) : (
        <NarrativeCommunityDefaultHeader
          title={title}
          hasBreadcrumbs={hasBreadcrumbs}
        />
      )}
      <div className="mt-4 grid text-center lg:hidden">
        <NarrativeCreateButton companyId={companyId} />
      </div>
    </div>
  );
};
